import React from "react";
import { InView } from 'react-intersection-observer';
import { CheckCircleIcon } from "@heroicons/react/solid";

const WhyUs = () => {
  const features = [
    {
      title: "Thousands of Templates",
      gradient: "from-purple-500 to-pink-500"
    },
    {
      title: "Ready-Made Festival Posters",
      gradient: "from-blue-500 to-cyan-500"
    },
    {
      title: "AI-Powered Editing Tools",
      gradient: "from-emerald-500 to-teal-500"
    },
    {
      title: "Easy Business Promotion",
      gradient: "from-orange-500 to-red-500"
    },
    {
      title: "Birthday & Anniversary Reminders",
      gradient: "from-indigo-500 to-purple-500"
    },
    {
      title: "Professional Logo Maker",
      gradient: "from-pink-500 to-rose-500"
    },
    {
      title: "Daily Online Panchang",
      gradient: "from-yellow-500 to-orange-500"
    },
    {
      title: "Business Spotlight Visibility",
      gradient: "from-green-500 to-emerald-500"
    },
    {
      title: "Affordable ₹499/Year Plan",
      gradient: "from-violet-500 to-purple-500"
    },
    {
      title: "Earn ₹200 Per Referral",
      gradient: "from-teal-500 to-green-500"
    }
  ];

  return (
    <div className="bg-gray-900 py-20">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-4xl sm:text-5xl font-bold mb-6">
          <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
            Why Choose Edit Ezy?
          </span>
        </h2>
        <p className="text-lg text-gray-400 mb-4 max-w-3xl mx-auto">
          Join thousands of satisfied users who create stunning posters every day
        </p>
        <p className="text-xl sm:text-2xl font-bold mb-12">
          <span className="bg-gradient-to-r from-purple-400 via-pink-400 to-purple-400 bg-clip-text text-transparent">
            Edit Ezy — Design Less. Share More. Grow Faster.
          </span>
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-5 gap-6 max-w-7xl mx-auto">
          {features.map((feature, index) => (
            <InView key={index} triggerOnce={true} threshold={0.5}>
              {({ inView, ref }) => (
                <div
                  ref={ref}
                  className={`bg-gray-800 rounded-xl p-6 flex items-center gap-4 border border-gray-700 hover:border-gray-600 transition-all duration-300 transform hover:-translate-y-1 hover:shadow-xl ${
                    inView ? 'animate__animated animate__fadeIn' : 'opacity-0'
                  }`}
                  style={{ animationDelay: `${index * 100}ms` }}
                >
                  <CheckCircleIcon className={`w-8 h-8 flex-shrink-0 bg-gradient-to-br ${feature.gradient} rounded-full p-1`} />
                  <p className="text-gray-200 font-semibold text-left text-sm sm:text-base">{feature.title}</p>
                </div>
              )}
            </InView>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhyUs;